module.exports = __webpack_public_path__ + "static/104_home-8058d42ef4e1c46ebb09cc0dc39e4d64.png";